// **********************************************************


export const geoConvertLib = (function () {
    function Lv03ToLv095(pointArray: any) {
        pointArray[0] = Math.round(pointArray[0]);
        pointArray[1] = Math.round(pointArray[1]);

        pointArray[0] = pointArray[0] + 2000000;
        pointArray[1] = pointArray[1] + 1000000;
        return pointArray;
    }

    function Lv095ToLv03(pointArray: any) {
        pointArray[0] = Math.round(pointArray[0]);
        pointArray[1] = Math.round(pointArray[1]);

        pointArray[0] = pointArray[0] - 2000000;
        pointArray[1] = pointArray[1] - 1000000;
        return pointArray;
    }

    // Convert WGS lat/lng (° dec) to CH x
    function WGStoCHx(lat: number, lng: number) {
        // Convert decimal degrees to sexagesimal seconds
        lat = DECtoSEX(lat);
        lng = DECtoSEX(lng);

        // Auxiliary values (% Bern)
        const latAux = (lat - 169028.66) / 10000;
        const lngAux = (lng - 26782.5) / 10000;

        // Process X
        const x =
            200147.07 +
            308807.95 * latAux +
            3745.25 * Math.pow(lngAux, 2) +
            76.63 * Math.pow(latAux, 2) -
            194.56 * Math.pow(lngAux, 2) * latAux +
            119.79 * Math.pow(latAux, 3);

        return x;
    }

    // Convert WGS lat/lng (° dec) to CH y: number
    function WGStoCHy(lat: number, lng: number) {
        // Convert decimal degrees to sexagesimal seconds
        lat = DECtoSEX(lat);
        lng = DECtoSEX(lng);

        // Auxiliary values (% Bern)
        const latAux = (lat - 169028.66) / 10000;
        const lngAux = (lng - 26782.5) / 10000;

        // Process y: number
        const y =
            600072.37 +
            211455.93 * lngAux -
            10938.51 * lngAux * latAux -
            0.36 * lngAux * Math.pow(latAux, 2) -
            44.54 * Math.pow(lngAux, 3);

        return y;
    }

    function CHtoWGS(y: number, x: number) {
        return [CHtoWGSlng(y, x), CHtoWGSlat(y, x)];
    }

    // Convert CH y/x to WGS lat
    function CHtoWGSlat(y: number, x: number) {
        // Converts military to civil and to unit = 1000km
        // Auxiliary values (% Bern)
        const yAux = (y - 600000) / 1000000;
        const xAux = (x - 200000) / 1000000;

        // Process lat
        let lat =
            16.9023892 +
            3.238272 * xAux -
            0.270978 * Math.pow(yAux, 2) -
            0.002528 * Math.pow(xAux, 2) -
            0.0447 * Math.pow(yAux, 2) * xAux -
            0.014 * Math.pow(xAux, 3);

        // Unit 10000" to 1 " and converts seconds to degrees (dec)
        lat = (lat * 100) / 36;

        return lat;
    }

    // Convert CH y/x to WGS lng
    function CHtoWGSlng(y: number, x: number) {
        // Converts military to civil and	to unit = 1000km
        // Auxiliary values (% Bern)
        const yAux = (y - 600000) / 1000000;
        const xAux = (x - 200000) / 1000000;

        // Process lng
        let lng =
            2.6779094 +
            4.728982 * yAux +
            0.791484 * yAux * xAux +
            0.1306 * yAux * Math.pow(xAux, 2) -
            0.0436 * Math.pow(yAux, 3);

        // Unit 10000" to 1 " and converts seconds to degrees (dec)
        lng = (lng * 100) / 36;

        return lng;
    }

    // Convert angle in decimal degrees to sexagesimal seconds
    function DECtoSEX(angle: number) {
        // Extract DMS
        const deg = Math.round(angle);
        const min = Math.round((angle - deg) * 60);
        const sec = ((angle - deg) * 60 - min) * 60;

        // Result sexagesimal seconds
        return sec + min * 60.0 + deg * 3600.0;
    }

    function WGStoCH(lat: number, lng: number) {
        return [WGStoCHy(lat, lng), WGStoCHx(lat, lng)];
    }


    function WgsToLv95(lat: number, lng: number) {
        const lv03 = WGStoCH(lat, lng);
        const lv095 = Lv03ToLv095(lv03);
        const geoPoint = { lat: lv095[0], lng: lv095[1] };
        return geoPoint;
    }

    function Lv95ToWgs(lat: number, lng: number) {
        const lv03Fromlv095 = Lv095ToLv03([lat, lng]);
        const latLng = CHtoWGS(lv03Fromlv095[0], lv03Fromlv095[1]);
        const geoPoint = { lat: latLng[1], lng: latLng[0] };
        return geoPoint;
    }


    return {
        WGStoCH,
        WgsToLv95,
        Lv95ToWgs,
        Lv03ToLv095,
        Lv095ToLv03,
        CHtoWGS
    }
})()
